import * as React from 'react';
import { Popover } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { localizedString } from '@locale/locale';
import { PopoverProps } from 'antd/lib/popover';

export interface HelperPopoverProps extends React.HTMLAttributes<unknown> {
  localizedKey?: string;
  text?: string;
  popoverProps?: PopoverProps;
}

function getInnerHtml(text: string) {
  return {
    __html: text
  };
}

function helperPopover(props: HelperPopoverProps) {

  const content = props.localizedKey ? localizedString(props.localizedKey) : props.text;

  const iconProps = {
    ...props,
    text: undefined,
    localizedKey: undefined
  };

  return <Popover
    {...props.popoverProps}
    content={<div style={{ width: 300 }}
      dangerouslySetInnerHTML={getInnerHtml(content)}
    />}
  >
    <QuestionCircleOutlined
      style={{ marginLeft: 4, marginRight: 4 }}
      {...iconProps}
    />
  </Popover >;
}

export const HelperPopover = helperPopover;
